"use client";
import ArrowButton from "components/General/ButtonGsfurn/ArrowButton.js";
import { useEffect, useRef, useState } from "react";
import { register } from "swiper/element";

function extractFromInnerHTML(html) {
  if (!html) return { url: undefined, alt: "" };
  const url = (html.match(/<img[^>]+src=["']([^"']+)["']/i) || [])[1];
  const alt = (html.match(/<img[^>]+alt=["']([^"']*)["']/i) || [])[1] ?? "";
  return { url, alt };
}

const GallerySlider = ({ images, clickedImage }) => {
  const swiperElRef = useRef(null);
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const slides_count = images?.length || 0;

  useEffect(() => {
    register();

    if (!swiperElRef.current) return;

    const params = {
      slidesPerView: 1,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      on: {
        slideChange(s) {
          setActiveIndex(s.activeIndex);
        },
        init(s) {
          setActiveIndex(s.activeIndex);
        },
      },
      navigation: {
        nextEl: nextRef.current,
        prevEl: prevRef.current,
      },
    };

    Object.assign(swiperElRef.current, params);
    swiperElRef.current.initialize?.();

    const swiper = swiperElRef.current.swiper;
    if (swiper && (!swiper.params.navigation.nextEl || !swiper.params.navigation.prevEl)) {
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.navigation.update();
    }
  }, []);

  return (
    <div className="relative">
      <swiper-container
        init="false"
        ref={swiperElRef}
        initial-slide={clickedImage}
        observer="true"
        observeparents="true"
        style={{
          display: "block",
          width: "100%",
          height: "min(80vh, calc(100vh - 10rem))",
        }}
      >
        {(images || []).map((image, i) => {
          const { additional_data } = image?.attrs || {};
          let { id, url, alt } = additional_data || {};

          if (!url && typeof image?.innerHTML === "string") {
            const parsed = extractFromInnerHTML(image.innerHTML);
            url = parsed.url ?? url;
            alt = parsed.alt ?? alt ?? "";
          }
          const key = id ?? i;

          return (
            <swiper-slide key={key} style={{ height: "100%" }}>
              <div className="flex justify-center w-full h-full overflow-hidden rounded-md align-center">
                {url && (
                  <img
                    src={url}
                    alt={typeof alt === "string" ? alt : ""}
                    className="block object-contain w-full h-full"
                  />
                )}
              </div>
            </swiper-slide>
          );
        })}
      </swiper-container>

      {slides_count > 1 && (
        <div className="absolute inset-0 z-10 flex items-center justify-between px-8 pointer-events-none">
          <button
            type="button"
            ref={prevRef}
            aria-label="Vorige"
            className={`pointer-events-auto rotate-180 transition-opacity ${
              activeIndex === 0 ? "opacity-40 cursor-default pointer-events-none" : "opacity-100"
            }`}
          >
            <ArrowButton />
          </button>

          <button
            type="button"
            ref={nextRef}
            aria-label="Volgende"
            className={`pointer-events-auto transition-opacity ${
              activeIndex + 1 === slides_count ? "opacity-40 cursor-default pointer-events-none" : "opacity-100"
            }`}
          >
            <ArrowButton />
          </button>
        </div>
      )}
    </div>
  );
};

export default GallerySlider;
